import configureStore from './store'
import { getAsyncInjectors } from './utils/asyncInjectors'
import history from './utils/history'
import registerSagas from './containers/Register/sagas'
import forgotPasswordSagas from './containers/ForgotPassword/sagas'

export const store = configureStore({}, history)

const { injectSagas } = getAsyncInjectors(store)

injectSagas(registerSagas)
injectSagas(forgotPasswordSagas)
